import "./DashboardStats.css";

import {
  MdShoppingBag,
  MdRestaurantMenu,
  MdBakeryDining,
  MdLocalDining,
  MdLocalGroceryStore,
  MdCelebration,
  MdCurrencyRupee,
  MdStar,
} from "react-icons/md";

function DashboardStats({ stats = {}, provider = {} }) {
  const providerType = provider.providerType;

  const formatCurrency = (amount = 0) =>
    new Intl.NumberFormat("en-IN").format(amount);

  const getInventoryCard = () => {
    switch (providerType) {
      case "Bakery":
        return {
          icon: <MdBakeryDining />,
          title: "Total Products",
          value: stats.totalProducts ?? stats.totalFoods ?? 0,
          color: "#f97316",
        };

      case "Restaurant":
        return {
          icon: <MdRestaurantMenu />,
          title: "Total Menu",
          value: stats.totalFoods ?? 0,
          color: "#f97316",
        };

      case "Hotel":
        return {
          icon: <MdLocalDining />,
          title: "Total Menu",
          value: stats.totalFoods ?? 0,
          color: "#f97316",
        };

      case "Catering":
        return {
          icon: <MdCelebration />,
          title: "Total Packages",
          value: stats.totalPackages ?? stats.totalFoods ?? 0,
          color: "#f97316",
        };

      case "Provision Store":
        return {
          icon: <MdLocalGroceryStore />,
          title: "Total Items",
          value: stats.totalItems ?? stats.totalFoods ?? 0,
          color: "#f97316",
        };

      default:
        return {
          icon: <MdRestaurantMenu />,
          title: "Total Foods",
          value: stats.totalFoods ?? 0,
          color: "#f97316",
        };
    }
  };

  const cards = [
    {
      icon: <MdShoppingBag />,
      title: "Today's Orders",
      value: stats.todayOrders ?? 0,
      color: "#2563eb",
    },

    getInventoryCard(),

    {
      icon: <MdCurrencyRupee />,
      title: "Today's Earnings",
      value: `₹${formatCurrency(stats.todayEarnings)}`,
      color: "#16a34a",
    },

    {
      icon: <MdStar />,
      title: "Rating",
      value: Number(provider.rating || 0).toFixed(1),
      color: "#eab308",
    },
  ];

  return (
    <div className="dashboard-stats">
      {cards.map((card, index) => (
        <div className="stats-card" key={index}>
          <div
            className="stats-icon"
            style={{ background: card.color }}
          >
            {card.icon}
          </div>

          <div className="stats-content">
            <h4>{card.title}</h4>
            <h2>{card.value}</h2>
          </div>
        </div>
      ))}
    </div>
  );
}

export default DashboardStats;